import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Seo from "@/components/Seo";
import { Nav, scrollToSection } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Manifesto } from "@/components/Manifesto";
import { Values } from "@/components/Values";
import { Practices } from "@/components/Practices";
import { Approach } from "@/components/Approach";
import { Insights } from "@/components/Insights";
import { Leadership } from "@/components/Leadership";
import { Contact, Footer } from "@/components/Contact";

export default function HomePage() {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
      return undefined;
    }
    const timers = [350, 900, 1600].map((ms) => setTimeout(() => scrollToSection(hash), ms));
    return () => timers.forEach(clearTimeout);
  }, [hash]);

  return (
    <div className="grain bg-[#FAFAF5] min-h-screen">
      <Seo
        title="Synergy Next — Strategy. People. Impact."
        siteName="Synergy Next"
        image="/images/logo.jpeg"
        description="An elite management and institutional consultancy partnering with business owners, promoters, doctors, educators and leadership teams across India. Built on a 30-year legacy."
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "Synergy Next",
          slogan: "Strategy. People. Impact.",
          logo: "/images/logo.jpeg",
          email: "connect@synergynext.co.in",
          address: {
            "@type": "PostalAddress",
            streetAddress: "Indu Niwas, 6th Lane, Prabhat Road",
            addressLocality: "Pune",
            postalCode: "411004",
            addressCountry: "IN",
          },
        }}
      />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Values />
        <Practices />
        <Approach />
        <Insights />
        <Leadership />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
